<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title></title>
  <link rel="icon" type="image/png" sizes="16x16" href="assets/images/favicon.png">
</head>

<body class="skin-default-dark fixed-layout">
<section id="wrapper" class="error-page">
  <div class="row">
    <div class="col-lg-6 pl-5 pr-5 error_img">
      <img src="assets/images/background/401.png" width="600" alt="" class="img-fluid" style="float: right">
    </div>
    <div class="col-lg-4 mt-auto mb-auto mobile-marg">
      <div class="error-body">
        <h1>401 error</h1>
        <h2 class="text-uppercase">Unauthorized !</h2>
        <p class="m-t-30 m-b-30 error-text">The server understood the request but refuses to authorize it. This status
          is similar to 401 , but in this case, re-authenticating will make no difference.
        </p>
        <p class="text-muted">
          If the problem persist, please feel free to communicate via phone or email to the IT department at:
        </p>
        <p class="text-muted" *ngIf="false">
          eMail: <a href="mailto:support@usclaro.com" class="claroredtext">{{ 'suport@usclaro.com' }}</a> <br> eMail: <a
          href="mailto:support@usclaro.com" class="claroredtext">{{ 'ittickets@usclaro.com' }}</a>
          <br> Phone-1: +1 123 456 7890 <br> Phone-2: +1 123 456 7890
        </p>
        <a *ngIf="false" disabled href="javascript:void(0)"
           class="btn btn-danger btn-rounded waves-effect waves-light m-b-40">
          <i class="mdi mdi-arrow-left"></i> Back to home
        </a>
      </div>
    </div>
    <div class="col-lg-12">
      <p class="text-center mb-0">
        <img src="assets/images/logo_black_letters.png" width="100" alt="">
      </p>
    </div>
  </div>
</section>
</body>

</html>
